import { toast } from "react-toastify"
import ThemeMaker from "../../components/thememaker"
import { useState, useEffect } from "react"
import axios from "axios"
import { config } from "../../utils/config"
import { useHistory } from "react-router-dom"
import { tokenDecode } from "../../utils/helper"

export default function Ticketsupport() {
    const { apiEndpoint } = config
    const history = useHistory()

    const decoded = tokenDecode();
    const tokenData = decoded?.data || decoded || {};
    const userObj = Array.isArray(tokenData?.user) ? tokenData?.user[0] : (tokenData?.user || {});
    const sellerDataObj = Array.isArray(tokenData?.seller_data) ? tokenData?.seller_data[0] : (tokenData?.seller_data || {});
    const sellerObj = Array.isArray(tokenData?.seller) ? tokenData?.seller[0] : (tokenData?.seller || {});

    const rawSellerType = (
        sellerDataObj?.seller_type ||
        sellerObj?.seller_type ||
        userObj?.seller_type ||
        ""
    ).toString().trim().toLowerCase();
    // console.log("dfg56df5f5f6f5f", tokenData?.user[0]?.parent_id)
    const admincheck = tokenData?.user[0]?.parent_id

    // Check if seller_type is Admin or user role_id is 1
    const isAdminUser = rawSellerType === "admin" || String(userObj?.role_id) === "1" || admincheck === "0";


    const [formData, setformData] = useState({
        // Seller 3 fields
        name: "",
        number: "",
        email: "",

        // Admin 6 fields
        org_person_name: "",
        org_email: "",
        org_phone: "",
        gro_person_name: "",
        gro_email: "",
        gro_phone: ""
    })
    const [existingId, setExistingId] = useState(null)
    const [isEdit, setIsEdit] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        getOrganizationDetails()
    }, [isAdminUser])

    async function getOrganizationDetails() {
        try {
            const fetchUrl = isAdminUser
                ? `${apiEndpoint}/snp/igm/getorgsupport`
                : `${apiEndpoint}/snp/igm/getSellerSupport`;

            const { data } = await axios({
                url: fetchUrl,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                }
            });

            const list = data?.data || data?.igmDetails || [];
            const details = Array.isArray(list) ? list[0] : list;

            if (details) {
                if (isAdminUser) {
                    setformData((prev) => ({
                        ...prev,
                        org_person_name: details.org_person_name || "",
                        org_email: details.org_email || "",
                        org_phone: details.org_phone || "",
                        gro_person_name: details.gro_person_name || "",
                        gro_email: details.gro_email || "",
                        gro_phone: details.gro_phone || ""
                    }));
                } else {
                    setformData((prev) => ({
                        ...prev,
                        name: details.support_person_name || details.org_person_name || "",
                        number: details.support_phone || details.org_phone || "",
                        email: details.support_email || details.org_email || ""
                    }));
                }
                setExistingId(details.id || null);
                setIsEdit(true);
            }
        } catch (err) {
            console.log("Error fetching details----", err);
        }
    }

    function onChangeHandler(e) {
        const { name, value } = e.target;

        // Name fields: accept ONLY alphabets and spaces (no numbers or special characters)
        if (name === "org_person_name" || name === "gro_person_name" || name === "name") {
            const filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
            setformData((prev) => ({ ...prev, [name]: filteredValue }));
            return;
        }

        // Phone fields: accept ONLY digits and limit to max 10 digits
        if (name === "org_phone" || name === "gro_phone" || name === "number") {
            const filteredValue = value.replace(/\D/g, "").slice(0, 10);
            setformData((prev) => ({ ...prev, [name]: filteredValue }));
            return;
        }

        setformData((prev) => ({
            ...prev,
            [name]: value
        }));
    }

    async function submitHandler() {
        let payload = {};
        let submitUrl = "";

        const nameRegex = /^[a-zA-Z\s]+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/;

        if (isAdminUser) {
            let { org_person_name, org_email, org_phone, gro_person_name, gro_email, gro_phone } = formData;

            // 1. Organization Person Name
            if (!org_person_name || !org_person_name.trim()) {
                toast.error("Please enter Organization Person Name");
                return;
            }
            if (!nameRegex.test(org_person_name.trim())) {
                toast.error("Organization Person Name should contain only letters (no numbers or special characters)");
                return;
            }

            // 2. Organization Email
            if (!org_email || !org_email.trim()) {
                toast.error("Please enter Organization Email");
                return;
            }
            if (!emailRegex.test(org_email.trim())) {
                toast.error("Please enter a valid Organization Email address");
                return;
            }

            // 3. Organization Phone
            if (!org_phone || !org_phone.trim()) {
                toast.error("Please enter Organization Phone");
                return;
            }
            if (!phoneRegex.test(org_phone.trim())) {
                toast.error("Organization Phone must be exactly 10 digits");
                return;
            }

            // 4. GRO Person Name
            if (!gro_person_name || !gro_person_name.trim()) {
                toast.error("Please enter GRO Person Name");
                return;
            }
            if (!nameRegex.test(gro_person_name.trim())) {
                toast.error("GRO Person Name should contain only letters (no numbers or special characters)");
                return;
            }

            // 5. GRO Email
            if (!gro_email || !gro_email.trim()) {
                toast.error("Please enter GRO Email");
                return;
            }
            if (!emailRegex.test(gro_email.trim())) {
                toast.error("Please enter a valid GRO Email address");
                return;
            }

            // 6. GRO Phone
            if (!gro_phone || !gro_phone.trim()) {
                toast.error("Please enter GRO Phone");
                return;
            }
            if (!phoneRegex.test(gro_phone.trim())) {
                toast.error("GRO Phone must be exactly 10 digits");
                return;
            }

            submitUrl = `${apiEndpoint}/snp/igm/org_support`;
            payload = {
                org_phone: org_phone.trim(),
                org_person_name: org_person_name.trim(),
                org_email: org_email.trim(),
                gro_phone: gro_phone.trim(),
                gro_email: gro_email.trim(),
                gro_person_name: gro_person_name.trim()
            };
        } else {
            let { name, email, number } = formData;

            // 1. Support Name
            if (!name || !name.trim()) {
                toast.error("Please enter Support Name");
                return;
            }
            if (!nameRegex.test(name.trim())) {
                toast.error("Support Name should contain only letters (no numbers or special characters)");
                return;
            }

            // 2. Support Email
            if (!email || !email.trim()) {
                toast.error("Please enter Support Email");
                return;
            }
            if (!emailRegex.test(email.trim())) {
                toast.error("Please enter a valid Support Email address");
                return;
            }

            // 3. Support Contact Number
            if (!number || !number.trim()) {
                toast.error("Please enter Support Contact Number");
                return;
            }
            if (!phoneRegex.test(number.trim())) {
                toast.error("Support Contact Number must be exactly 10 digits");
                return;
            }

            submitUrl = `${apiEndpoint}/snp/igm/createsellerSupport`;
            payload = {
                support_phone: number.trim(),
                support_email: email.trim(),
                support_person_name: name.trim()
            };
        }

        if (existingId) {
            payload.id = existingId;
        }

        try {
            setIsSubmitting(true);
            const { data } = await axios({
                url: submitUrl,
                method: "POST",
                data: payload,
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                }
            });

            if (data?.status === true) {
                toast.success(data?.message || "Details saved successfully");
                getOrganizationDetails();
            } else {
                toast.error(data?.message || "Failed to save details");
            }
        } catch (err) {
            const errMsg = err?.response?.data?.message || "Something Went Wrong! Please try again later.";
            toast.error(errMsg);
        } finally {
            setIsSubmitting(false);
        }
    }

    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    return (
        <ThemeMaker>
            <div className="row w-100 m-0 mt-1">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold text-primary text-left">
                                Ticket Support
                            </h6>
                            {isAdminUser && (
                                <button
                                    className="btn btn-primary btn-sm p-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => history.push("/ticketsupportlist")}
                                >
                                    All Ticket Support List
                                </button>
                            )}
                        </div>

                        <div className="card-body" style={{ minHeight: "70vh" }}>
                            {isAdminUser ? (
                                /* ---------------- ADMIN FORM (6 FIELDS) ---------------- */
                                <>
                                    <h6 className="m-0 font-weight-bold text-primary text-left mb-3">Organization Support Details</h6>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Organization Person Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="org_person_name"
                                                    className="form-control"
                                                    // placeholder="e.g. Xpressbaazaar"
                                                    value={formData.org_person_name}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Organization Email <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    name="org_email"
                                                    className="form-control"
                                                    // placeholder="e.g. info.xpressbaazaar@ens.enterprises"
                                                    value={formData.org_email}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Organization Phone <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="org_phone"
                                                    className="form-control"
                                                    // placeholder="e.g. 8899007766"
                                                    value={formData.org_phone}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="my-3" />

                                    <h6 className="m-0 font-weight-bold text-primary text-left mb-3"> GRO Details</h6>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    GRO Person Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="gro_person_name"
                                                    className="form-control"
                                                    // placeholder="GRO support"
                                                    value={formData.gro_person_name}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    GRO Email <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    name="gro_email"
                                                    className="form-control"
                                                    // placeholder="e.g. info.xpressbaazaar@ens.enterprises"
                                                    value={formData.gro_email}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    GRO Phone <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="gro_phone"
                                                    className="form-control"
                                                    // placeholder="e.g. 8899007766"
                                                    value={formData.gro_phone}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                /* ---------------- SELLER FORM (3 FIELDS) ---------------- */
                                <>
                                    <h6 className="m-0 font-weight-bold text-primary text-left mb-3">Support Details</h6>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Support Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    // placeholder="Enter Name"
                                                    value={formData.name}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Support Email <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control"
                                                    // placeholder="Enter Email"
                                                    value={formData.email}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <div className="form-group">
                                                <label className="genericlabel">
                                                    Support Contact Number <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="number"
                                                    className="form-control"
                                                    maxLength={10}
                                                    value={formData.number}
                                                    onChange={onChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="row px-2 mt-3">
                                <button className="btn btn-primary" onClick={submitHandler} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            {isEdit ? "Updating..." : "Creating..."}
                                        </>
                                    ) : (
                                        isEdit ? "Update" : "Create"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ThemeMaker>
    )
}
